import { FC } from 'react';

import { usePaymentTermsLabel } from '@common/hooks/usePaymentTermsLabel';
import { PaymentTerms } from 'shared-types/Common';

import { Container } from './PaymentTermsBadge.styles';

type PaymentTermsBadgeProps = {
  paymentTerms?: PaymentTerms | null;
};

export const PaymentTermsBadge: FC<PaymentTermsBadgeProps> = ({ paymentTerms }) => {
  const getPaymentTermsLabel = usePaymentTermsLabel();
  const label = getPaymentTermsLabel(paymentTerms);

  if (!label) {
    return null;
  }

  return <Container data-testid="payment-terms-badge">{label}</Container>;
};
